export const IS_PROD = import.meta.env.VITE_IS_PRODUCTION === 'true';
const VITE_API_BASE_URL = IS_PROD
  ? import.meta.env.VITE_API_BASE_URL_PROD
  : import.meta.env.VITE_API_BASE_URL_DEV;
export const BASE_URL = VITE_API_BASE_URL || window.location.origin;
